import React, { useState } from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Youtube, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const [logoError, setLogoError] = useState(false);

  return (
    <footer className="Footer_footer">
      <div className="container">
        <div className="Footer_grid">
          
          {/* Brand */}
          <div className="Footer_brandCol">
            <div className="Footer_brandHeader">
              {!logoError ? (
                <img
                  src="/logo.png"
                  alt="Logo Lakpesdam"
                  className="Footer_logoImage"
                  width="44"
                  height="44"
                  onError={() => setLogoError(true)}
                />
              ) : (
                <div className="Footer_brandIcon">L</div>
              )}
              <div className="Footer_brandName">
                <h3>Lakpesdam</h3>
                <span className="Footer_brandSub">PBNU</span>
              </div>
            </div>
            <p className="Footer_brandDesc">
              Lembaga Kajian dan Pengembangan Sumber Daya Manusia Pengurus Besar Nahdlatul Ulama.
            </p>
            <div className="Footer_socialLinks">
              <a href="https://x.com/lakpesdam_pbnu?lang=en" className="Footer_socialIcon" aria-label="Twitter/X Lakpesdam PBNU" target="_blank" rel="noopener noreferrer"><Twitter size={20} /></a>
              <a href="https://www.facebook.com/lakpesdampbnu/" className="Footer_socialIcon" aria-label="Facebook Lakpesdam PBNU" target="_blank" rel="noopener noreferrer"><Facebook size={20} /></a>
              <a href="https://www.instagram.com/lakpesdam_pbnu/?hl=id" className="Footer_socialIcon" aria-label="Instagram Lakpesdam PBNU" target="_blank" rel="noopener noreferrer"><Instagram size={20} /></a>
              <a href="https://www.youtube.com/channel/UCAXV9NWByHzVO4e6g5fUcyQ" className="Footer_socialIcon" aria-label="YouTube Lakpesdam PBNU" target="_blank" rel="noopener noreferrer"><Youtube size={20} /></a>
              <a href="https://www.linkedin.com/company/lakpesdam-pbnu" className="Footer_socialIcon" aria-label="LinkedIn Lakpesdam PBNU" target="_blank" rel="noopener noreferrer"><Linkedin size={20} /></a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="Footer_title">Jelajahi</h4>
            <ul className="Footer_list">
              <li>
                <Link to="/tentang" className="Footer_link">Tentang Kami</Link>
              </li>
              <li>
                <Link to="/riset" className="Footer_link">Riset & Publikasi</Link>
              </li>
              <li>
                <Link to="/program-inklusi" className="Footer_link">Program Strategis</Link>
              </li>
              <li>
                <Link to="/berita" className="Footer_link">Kabar Lakpesdam</Link>
              </li>
              <li>
                <Link to="/privasi" className="Footer_link">Kebijakan Privasi</Link>
              </li>
            </ul>
          </div>

          {/* Topics */}
          <div>
            <h4 className="Footer_title">Fokus Kajian</h4>
            <ul className="Footer_list">
              <li>
                <Link to="/berita" className="Footer_link">Islam & Negara</Link>
              </li>
              <li>
                <Link to="/berita" className="Footer_link">Ekonomi Umat</Link>
              </li>
              <li>
                <Link to="/berita" className="Footer_link">Lingkungan Hidup</Link>
              </li>
              <li>
                <Link to="/berita" className="Footer_link">Pendidikan</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="Footer_title">Kontak</h4>
            <ul className="Footer_list">
              <li className="Footer_contactItem">
                <MapPin size={18} className="Footer_contactIcon" />
                <span>Jl. KH. Ramli No. 20A, Menteng Dalam Tebet. Jakarta</span>
              </li>
              <li className="Footer_contactItem">
                <Mail size={18} className="Footer_contactIcon" />
                <span>lakpesdam@lakpesdam.or.id</span>
              </li>
              <li className="Footer_contactItem">
                <Phone size={18} className="Footer_contactIcon" />
                <span>+62 21 829 8855</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="Footer_copyright">
          <p>&copy; {new Date().getFullYear()} Lakpesdam PBNU. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
